/* Yuvakart — product sticky bar
   Glass bar · ADD TO CART (black) · BUY NOW (red) · no offer strip.
   Colours are applied INLINE with !important so the section's
   #shopify-section-xxx rules cannot override them. */
(function(){
  var ATC = '#16120c', ATC_H = '#241d13', ATC_FG = '#f6e7c9';
  var BUY = '#c0392b', BUY_H = '#a12f23', BUY_FG = '#ffffff';

  var CSS = [
    '.pp__sticky{background:rgba(252,247,238,.72) !important;',
      'backdrop-filter:blur(32px) saturate(180%) !important;',
      '-webkit-backdrop-filter:blur(32px) saturate(180%) !important;',
      'border:none !important;border-top:1px solid rgba(255,255,255,.6) !important;',
      'box-shadow:0 -16px 46px -18px rgba(60,40,12,.34), inset 0 1px 0 rgba(255,255,255,.75) !important;}',
    '.pp__sticky .in{display:block !important;padding:0 !important;max-width:none !important;margin:0 !important;}',
    '.yks__row{max-width:1180px;margin:0 auto;display:flex;align-items:center;gap:18px;padding:13px 24px 15px;}',
    '.yks__img{width:50px;height:50px;border-radius:12px;object-fit:cover;flex:none;',
      'border:1px solid rgba(255,255,255,.65);box-shadow:0 6px 15px -7px rgba(60,40,12,.5);}',
    '.yks__info{min-width:0;flex:1;}',
    '.yks__title{display:block;font-size:12.5px;font-weight:600;color:#6e6355;white-space:nowrap;',
      'overflow:hidden;text-overflow:ellipsis;max-width:360px;margin-bottom:2px;letter-spacing:.01em;}',
    '.yks__price{display:flex;align-items:baseline;gap:10px;flex-wrap:wrap;}',
    '.yks__now{font-size:22px;font-weight:800;color:#2a2118;letter-spacing:-.015em;line-height:1;}',
    '.yks__mrp{font-size:13.5px;color:#a2947c;text-decoration:line-through;}',
    '.yks__off{font-size:12.5px;font-weight:800;color:#178a5a;letter-spacing:.02em;}',
    '.yks__btns{display:flex;gap:12px;flex:none;margin-left:auto;}',
    '.yks__b{position:relative;overflow:hidden;height:52px;min-width:172px;padding:0 28px;border:none !important;',
      'border-radius:13px;font-family:inherit;font-size:13.5px;font-weight:800;letter-spacing:.07em;',
      'cursor:pointer;text-transform:uppercase;',
      'transition:transform .2s cubic-bezier(.22,1,.36,1), filter .2s ease;}',
    '.yks__b::after{content:"";position:absolute;left:0;right:0;top:0;height:44%;pointer-events:none;',
      'background:linear-gradient(180deg,rgba(255,255,255,.18),rgba(255,255,255,0));}',
    '.yks__b:hover{transform:translateY(-2px);}',
    '.yks__b:active{transform:translateY(0) scale(.98);}',
    '@media(max-width:860px){',
      '.yks__row{flex-wrap:wrap;gap:10px;padding:10px 14px 12px;}',
      '.yks__img{width:42px;height:42px;}',
      '.yks__title{max-width:none;font-size:11.5px;}',
      '.yks__now{font-size:19px;}',
      '.yks__btns{width:100%;order:3;margin-left:0;gap:10px;}',
      '.yks__b{flex:1;min-width:0;padding:0;height:48px;font-size:13px;}',
    '}'
  ].join('');

  function injectCSS(){
    if(document.getElementById('yks-css')) return;
    var s = document.createElement('style');
    s.id = 'yks-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function paint(btn, bg, fg, hover, glow){
    btn.style.setProperty('background', bg, 'important');
    btn.style.setProperty('background-image', 'none', 'important');
    btn.style.setProperty('color', fg, 'important');
    btn.style.setProperty('border', 'none', 'important');
    btn.style.setProperty('box-shadow', '0 12px 26px -10px ' + glow + ', inset 0 1px 0 rgba(255,255,255,.22)', 'important');
    btn.addEventListener('mouseenter', function(){ btn.style.setProperty('background', hover, 'important'); });
    btn.addEventListener('mouseleave', function(){ btn.style.setProperty('background', bg, 'important'); });
  }

  function txt(sel){ var el = document.querySelector(sel); return el ? el.textContent.trim() : ''; }

  function build(){
    var bar = document.querySelector('.pp__sticky');
    if(!bar || bar.getAttribute('data-yks')) return;
    var inner = bar.querySelector('.in');
    if(!inner) return;

    var img = inner.querySelector('img');
    var imgSrc = img ? img.getAttribute('src') : '';
    var title = txt('.pp__bb h1') || txt('.pp__sticky .tx b');
    var now = txt('.pp__now');
    var mrp = txt('.pp__mrp');
    var off = txt('.pp__off');

    var atcBtn = document.querySelector('.pp__atc');
    var soldOut = atcBtn ? atcBtn.hasAttribute('disabled') : false;

    bar.setAttribute('data-yks','1');

    /* strip removed — drop any previously injected one */
    var oldStrip = bar.querySelector('.yks__promo');
    if(oldStrip) oldStrip.remove();

    var html = '<div class="yks__row">';
    if(imgSrc){ html += '<img class="yks__img" src="' + imgSrc + '" alt="">'; }
    html += '<div class="yks__info">';
    if(title){ html += '<span class="yks__title">' + title + '</span>'; }
    html += '<span class="yks__price"><span class="yks__now">' + now + '</span>';
    if(mrp){ html += '<span class="yks__mrp">' + mrp + '</span>'; }
    if(off){ html += '<span class="yks__off">' + off + '</span>'; }
    html += '</span></div>';
    html += '<div class="yks__btns">' +
      '<button type="button" class="yks__b yks__atc" data-yks-atc' + (soldOut ? ' disabled' : '') + '>' +
        (soldOut ? 'Sold out' : 'Add to cart') + '</button>' +
      '<button type="button" class="yks__b yks__buy" data-yks-buy' + (soldOut ? ' disabled' : '') + '>Buy now</button>' +
    '</div></div>';

    inner.innerHTML = html;

    var a = inner.querySelector('[data-yks-atc]');
    var b = inner.querySelector('[data-yks-buy]');

    if(soldOut){
      if(a) paint(a, '#cfc6b6', '#8d8375', '#cfc6b6', 'rgba(0,0,0,.12)');
      if(b) paint(b, '#cfc6b6', '#8d8375', '#cfc6b6', 'rgba(0,0,0,.12)');
    } else {
      if(a) paint(a, ATC, ATC_FG, ATC_H, 'rgba(22,18,12,.72)');
      if(b) paint(b, BUY, BUY_FG, BUY_H, 'rgba(192,57,43,.72)');
    }

    if(a) a.addEventListener('click', function(){
      var real = document.querySelector('.pp__atc');
      if(real && !real.hasAttribute('disabled')) real.click();
    });

    if(b) b.addEventListener('click', function(){
      var address = document.querySelector('.yk-address-trigger');
      if(address && !address.disabled) address.click();
    });
  }

  function run(){ injectCSS(); build(); }

  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', run); }
  else { run(); }
  window.addEventListener('load', run);
  setTimeout(run, 600); setTimeout(run, 1600);
  try{
    var t = null;
    new MutationObserver(function(){
      if(t) return;
      t = setTimeout(function(){ t = null; run(); }, 400);
    }).observe(document.body, {childList:true, subtree:true});
  }catch(e){}
})();